import { render, staticRenderFns } from "./EditForm.vue?vue&type=template&id=938e04fa&scoped=true"
import script from "./EditForm.vue?vue&type=script&lang=js"
export * from "./EditForm.vue?vue&type=script&lang=js"
import style0 from "./EditForm.vue?vue&type=style&index=0&id=938e04fa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "938e04fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('938e04fa')) {
      api.createRecord('938e04fa', component.options)
    } else {
      api.reload('938e04fa', component.options)
    }
    module.hot.accept("./EditForm.vue?vue&type=template&id=938e04fa&scoped=true", function () {
      api.rerender('938e04fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyPrice/OilPrice/EditForm.vue"
export default component.exports